import React from "react"
import { Alert, Button, ButtonGroup } from "reactstrap"
import { Container, TextContainer } from "./styles"
import { useState } from 'react';

const Alerts = (props) => {
    const [aceite, setAceite] = useState(() => { try { return localStorage.getItem('termgeo') === 'true' ? 1 : 0; } catch (e) { return 0; } });
    const bodyText = props.textBody;
    const aceitarTermo = () => { try { localStorage.setItem('termgeo', 'true'); } catch (e) { /* armazenamento indisponível: o termo volta na próxima visita */ } setAceite(1); window.location.reload(); };
    return (
        <>
            {
                aceite == 0 &&
                <div>
                    <Alert color={props.color}>
                        <h4 className="alert-heading">
                            {props.title || 'Alert'}
                        </h4>
                        <p>
                            <TextContainer> 
                                {bodyText.split('\n\n').map((section, index) => {
                                    const title = section.split(': ')[0] || '';
                                    const content = section.split(': ')[1] || '';
                                    return (
                                        <div key={index}>
                                            <span style={{ fontWeight: 'bold' }}>{title}</span>
                                            <span style={{ display: 'block', textAlign: 'left' }}>{content}</span>
                                            <br />
                                        </div>
                                    );
                                })}
                            </TextContainer>
                        </p>
                        <hr />
                        <Container>
                            <ButtonGroup className="d-flex justify-content-center">
                                <Button
                                    className='btn btn-success'
                                    onClick={aceitarTermo}
                                >
                                    {props.textButton || 'Aceitar'}
                                </Button>
                            </ButtonGroup>
                        </Container>
                    </Alert>
                </div>
            }
        </>
    )
}

export default Alerts